import { SxProps, Theme } from '@mui/material';
import { CrmColors } from '@layouts/pages/CRM/kanban-board/crm-theme';

export const listCardSx = (cc: CrmColors, active: boolean): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    px: 2,
    py: 1.5,
    border: `1px solid ${cc.border}`,
    borderRadius: '10px',
    bgcolor: cc.countBg,
    opacity: active ? 1 : 0.6,
    transition: 'border-color 160ms ease',
    '&:hover': { borderColor: cc.borderHover },
    '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
});

export const monoLineSx = (cc: CrmColors): SxProps<Theme> => ({
    fontFamily: 'monospace',
    fontSize: 12,
    color: cc.textSecondary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    mt: 0.25,
});

/// Sem cor, etiqueta neutra; com cor, borda e texto nela (aviso, por exemplo).
export const tagChipSx = (cc: CrmColors, color?: string): SxProps<Theme> => ({
    height: 22,
    fontSize: 11.5,
    fontWeight: 600,
    bgcolor: 'transparent',
    border: `1px solid ${color ?? cc.borderStrong}`,
    '& .MuiChip-label': { color: color ?? cc.textSecondary, px: 1 },
});

/// Cor só no ponto e no texto: fundo tingido some no escuro e briga com o cartão no claro.
export const statusPillSx = (cc: CrmColors, color: string): SxProps<Theme> => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.75,
    height: 26,
    px: 1.25,
    borderRadius: '13px',
    border: `1px solid ${cc.borderStrong}`,
    fontSize: 12,
    fontWeight: 600,
    color,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    '&::before': {
        content: '""',
        width: 7,
        height: 7,
        borderRadius: '50%',
        bgcolor: color,
    },
});

/// Campo de texto dos formulários de integração, no mesmo tom das superfícies do CRM.
export const integrationFieldSx = (cc: CrmColors): SxProps<Theme> => ({
    '& .MuiOutlinedInput-root': {
        bgcolor: cc.surfaceBg,
        borderRadius: '8px',
        color: cc.textPrimary,
        '& fieldset': { borderColor: cc.border },
    },
    '& .MuiInputBase-input': { color: cc.textPrimary },
    '& .MuiFormLabel-root': { color: cc.textSecondary },
});

export const eventChoiceSx = (cc: CrmColors, on: boolean): SxProps<Theme> => ({
    height: 30,
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: 12.5,
    bgcolor: on ? cc.accentSoftBg : 'transparent',
    color: on ? cc.onTint : cc.textSecondary,
    border: `1px solid ${on ? cc.accent : cc.borderStrong}`,
    '& .MuiChip-icon': { color: cc.accent, fontSize: 16 },
    '&:hover': { borderColor: on ? cc.accent : cc.borderHover },
});

export const switchRowSx = (cc: CrmColors): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    px: 1.5,
    py: 1,
    border: `1px solid ${cc.border}`,
    borderRadius: '8px',
    bgcolor: cc.countBg,
});
